import { render, staticRenderFns } from "./TransactionsView.vue?vue&type=template&id=21e9d222&"
import script from "./TransactionsView.vue?vue&type=script&lang=js&"
export * from "./TransactionsView.vue?vue&type=script&lang=js&"
import style0 from "./TransactionsView.vue?vue&type=style&index=0&id=21e9d222&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports